// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xMZq","toggleWrap":"styles_toggleWrap__2CJ7x","content":"styles_content__wazq2","selectAreaCode":"styles_selectAreaCode__3TypY"};